<template>
  <div>
    <v-icon
      v-if="layer.values_.icon_params"
      class="mr-2"
      size="16"
      color="white"
      :style="`height: 24px; width: 24px; border-radius: 50%;background-color: ${layer.values_.icon_params.background_color}`"
      >{{ layer.values_.icon_params.class }}</v-icon
    >
    <strong class="secondary--text text--lighten-1 layer-title">{{
      layer.values_.name
    }}</strong>
    <div v-if="enabledSublayer && layer.values_.id !== 9999" class="d-flex">
      <div class="d-flex pt-5" v-if="layer.values_.id == 100">
        <v-img src="@/assets/LegendaICE.svg" width="132" height="45"> </v-img>
      </div>
      <animation-player
        v-show="layer.values_.timeFeatures"
        :timeFeatures="layer.values_.timeFeatures"
        @changeTimeFeature="changeTimeFeature($event)"
      >
      </animation-player>
      <img
        v-show="layer.values_.url_caption"
        class="ml-2"
        :id="layer.values_.name"
        :src="layer.values_.url_caption"
        style="max-width: 250px"
        alt="legenda"
      />
      <html-legend-sublayer :htmlCaption="htmlCaption"> </html-legend-sublayer>
    </div>
  </div>
</template>

<script>
import AnimationPlayer from './AnimationPlayer.vue';
import HtmlLegendSublayer from './HtmlLegendSublayer.vue';
export default {
  name: 'RightSubLayerMapMenu',
  props: [
    'layer',
    'group',
    'showMenuLayer',
    'showMenuLayerPesticides',
    'showMenuLayerDiffuseLoads',
  ],
  components: {
    AnimationPlayer,
    HtmlLegendSublayer,
  },

  data: () => ({
    enabledSublayer: undefined,
    initialOpacity: undefined,
    erosion: undefined,
  }),
  created() {
    this.enabledSublayer = this.layer.values_.visible;
    this.initialOpacity = this.layer.values_.opacity * 100;
  },

  computed: {
    htmlCaption() {
      return this.layer.values_.caption_html &&
        (this.layer.values_.caption_html.alwaysVisible || this.enabledSublayer)
        ? this.layer.values_.caption_html
        : undefined;
    },
  },
  methods: {
    changeTimeFeature(timeFeature) {
      this.$emit('changeInputMenu', {
        eventName: 'changeTimeFeature',
        params: timeFeature,
      });
    },
    changeEnabledSublayer(visible) {
      this.$emit('changeInputMenu', {
        eventName: 'changeEnabledSublayer',
        params: {visible, layerId: this.layer.values_.id},
      });
    },
    changeOpacitySublayer(opacity) {
      this.$emit('changeInputMenu', {
        eventName: 'changeOpacitySublayer',
        params: {opacity, layerId: this.layer.values_.id},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12.0833px;
  line-height: 15px;
  text-transform: none;
  /* or 154% */
  color: #95a1ec;
}

::v-deep .theme--dark.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #95a1ec !important;
}

::v-deep .v-btn-toggle > .v-btn.v-btn--active {
  color: #95a1ec !important;
  opacity: 1;
}

::v-deep .theme--dark.v-btn.v-btn--has-bg {
  background-color: #212a35 !important;
}
</style>
